module.exports = __webpack_public_path__ + "static/img/talentenspel.60acf7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/talentenspel.jpg
// module id = K99d
// module chunks = 0